import {Component, Input} from '@angular/core';

@Component({
  selector: 'sb-network-share-option-status',
  templateUrl: './sb-network-share-option-status.component.html',
  styleUrls: ['./sb-network-share-option-status.component.scss'],
  standalone: false,
})
export class SbNetworkShareOptionStatusComponent {
  @Input() option: boolean;
}
